import { useCallback, useState } from 'react';
import { Button } from '@shared/components/Button';
import { AnchoredTooltip } from '@shared/components/tooltip';
import { i18n } from '@shared/util/i18n';

export function CopyButton({ text }: { text: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }, [text]);

  return (
    <AnchoredTooltip tooltip={copied ? i18n('common.copied') : i18n('common.copy')} position="top">
      <Button
        variant="tertiary"
        size="small"
        icon="squares-stacked"
        iconOnly
        onClick={handleCopy}
      />
    </AnchoredTooltip>
  );
}
